export default {
  activateLandingPageTitle: 'イベント',
  activateProductCardTitle: 'イベント',
  activateProductPageTitle: 'イベントを予約する',
  allProductsLandingPageTitle: 'ユニークな体験を予約する',
  apply: '適用',
  buyTickets: 'チケットを購入',
  cancel: 'キャンセル',
  clear: 'クリア',
  clearFilters: 'フィルターをクリア',
  discoverExperiences: '体験を探す',
  exclusive: '限定',
  experience: '体験',
  experiencePhotoOfListing: '{{listingTitle}}の体験写真{{photoNumber}}',
  experiences: '体験',
  filterExperiences: '体験を絞り込む',
  fromListingCard: 'から',
  hostedBy: 'ホスト：',
  hostLandingPageTitle: 'ローカル体験',
  hostProductCardTitle: 'ローカル体験',
  hostProductPageTitle: 'ローカル体験を予約する',
  landingPageTitle: 'ユニークな体験を予約する',
  mainLandingPageTitle: 'すべての体験',
  more: 'もっと見る',
  noExperiencesFound: '体験が見つかりませんでした',
  noExperiencesFoundFor: '該当する体験が見つかりませんでした',
  experiencesFoundCount: '{{count}}件の体験が見つかりました',
  profileImageOfHost: '{{hostName}}のプロフィール画像',
  reserve: '予約する',
  reserveLandingPageTitle: 'アクティビティと設備',
  reserveProductCardTitle: 'アクティビティ',
  reserveProductPageTitle: 'アクティビティと設備を予約する',
  resultsPageTitle: '体験とアクティビティを予約する',
};
